export default __webpack_public_path__ + "static/media/cert-fsi-cpttm-sc.a804286d.jpg";